const riot = require('riot');
import '../components/campaign/campaign.tag'
import '../components/campaigns.tag'
riot.tag2('page-campaigns', '<campaigns if="{!campaign_id}"></campaigns> <campaign if="{campaign_id}" campaign_id="{campaign_id}"></campaign>', '', '', function(opts) {
	  this.campaign_id = riotRoute.args[0] || false;
	  this.on('update',() => this.campaign_id = riotRoute.args[0] || false);
});
